// extracted by css-extract-rspack-plugin
export default {"strip":"EnvironmentStrip-module__strip__Vo42e","stripButton":"EnvironmentStrip-module__stripButton__ruBN7"};